import React, { useState, useEffect } from "react";
import arcBridge from 'frontend/js/arcBridge';

interface Props {
  settings: any;
  firstName?: string;
  recentOrder?: {
    status: string;
    financial_status?: string;
    label: string;
  };
}


const AccountDashboard = ({ settings, firstName, recentOrder }: Props) => {
  const [rewards, setRewards] = useState({ tier: "Silver", balance: 0 });
  const [loading, setLoading] = useState(true);


  useEffect(() => {
    async function fetchRewards() {
      try {
        const res = await arcBridge.getCustomerRewards();
        if (res?.success && res?.results) {
          const { tier = "Silver", points = 0 } = res.results;
          setRewards({
            tier,
            balance: points,
          });
        }
      } catch (error) {
        console.error("Failed to fetch customer rewards", error);
      } finally {
        setLoading(false);
      }
    }

    fetchRewards();
  }, []);

  const renderOrderStatus = () => {
    if (!recentOrder) return <div className="text-black">No recent orders</div>;

    switch (recentOrder.status) {
      case "complete":
        return <div className="text-[#36573B]">Delivered</div>;
      case "partial":
        return <div className="text-[#FA700C]">Partially Delivered</div>;
      case "fulfilled":
        return <div className="text-[#36573B]">Fulfilled</div>;
      case "unfulfilled":
        return <div className="text-[#FA700C]">In Process</div>;
      default:
        if (
          ["refunded", "voided", "expired"].includes(
            recentOrder.financial_status || ""
          )
        ) {
          return <div className="text-[#D12727]">Cancelled</div>;
        }
        return <div className="text-black">{recentOrder.label}</div>;
    }
  };
  
  return (
    <>
      <div className="w-full">
        <div className="account-header">
          <h1 className="flex items-end h2 account-header__title">
            <span className="lg:flex-none">Welcome back, {firstName}</span>
          </h1>
          <div className="icon-arrow-down-rounded account-header__icon"></div>
        </div>

        <div className="grid grid-cols-1 gap-5 mt-12 lg:grid-cols-2">
          <a
            href="/account?view=my-rewards"
            className="grid items-start border border-[#BBBBBD] p-4 lg:p-6 hover:no-underline hover:shadow-custom hover:bg-[#f5f5f5] hover:border-none"
          >
            <span className="w-20 h-[2px] bg-[#A2A9AD] mb-6"></span>
            <p className="pb-2 uppercase bc text-[#54565A]">
              My Rewards
            </p>
            <h3 className={loading ? "bc text-[#54565A] !normal-case" : "text-[#00263E] mb-2"}>
              {loading ? "Loading..." : rewards.tier}
            </h3>
            <div className="min-h-[150px] flex flex-col">
              <label className="blabel font-medium text-[#54565A]">
                Balance
              </label>
              <span className="text-black bcp">
                ${rewards.balance}
              </span>
            </div>
            <div className="flex self-end justify-between">
              <label className="text-[#00263E] text-sm/[18px] lg:text-base/[16px]">
                View Rewards
              </label>
              <i className="text-2xl text-[#00263E] icon-chevron-right"></i>
            </div>
          </a>
            
          <a
            href="/account?view=orders"
            className="grid items-start border border-[#BBBBBD] p-4 lg:p-6 hover:no-underline hover:shadow-custom hover:bg-[#f5f5f5] hover:border-none"
          >
            <span className="w-20 h-[2px] bg-[#A2A9AD] mb-6"></span>
            <p className="pb-2 uppercase bc text-[#54565A]">My Order History</p>
            <h3 className="text-[#00263E] mb-2">Recent Order</h3>
            <div className="min-h-[150px] flex flex-col">
              <label className="blabel font-medium text-[#54565A]">Status</label>
              <span className="text-black bcp">{renderOrderStatus()}</span>
            </div>
            <div className="flex self-end justify-between">
                <label className="text-[#00263E] text-sm/[18px] lg:text-base/[16px]">
                  See Order Details
                </label>
                <i className="text-2xl text-[#00263E] icon-chevron-right"></i>
            </div>
          </a>

          <a href="/account?view=personal-details" className="grid items-start border border-[#BBBBBD] p-4 lg:p-6 hover:no-underline hover:shadow-custom hover:bg-[#f5f5f5] hover:border-none">
            <span className="w-20 h-[2px] bg-[#A2A9AD] mb-6"></span>
            <p className="pb-2 uppercase bc text-[#54565A]">My Details</p>
            <h3 className="text-[#00263E] mb-2">Personal Details</h3>
            <div className="min-h-[150px] flex flex-col">
              <label className="blabel font-medium text-[#54565A]"></label>
              <span className="text-black bcp"></span>
            </div>
            <div className="flex self-end justify-between">
              <label className="text-[#00263E] text-sm/[18px] lg:text-base/[16px]">
                View Details
              </label>
              <i className="text-2xl text-[#00263E] icon-chevron-right"></i>
            </div>
          </a>
        </div>
      </div>
    </>
  );
};

export default AccountDashboard;